import { z } from 'zod';

export const produccionSearchSchema = z.object({
  /** Período YYYY-MM (default = mes en curso, computado en el componente). */
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional()
    .catch(undefined),
  /** UUID del ejecutivo o '__sin_asignar__' para los sin ejecutivo. */
  exec: z.string().optional().catch(undefined),
});

export type ProduccionSearch = z.infer<typeof produccionSearchSchema>;
